import { Table as TableComponent } from '@mantine/core'

import classNames from './table.module.css'

export const TableScrollContainer = TableComponent.ScrollContainer.extend({
  classNames,
})
